/*
 * @Author: HKuaiyin FE Chain
 * @Date: 2020-12-14 11:50:22
 * @Description: 任务处理
 * @FilePath: /vision-h5/src/root/index.js
 */
import $shandw from '@/lib/shandw';
// 签到弹窗，暂时保留原有逻辑后面有时间再重构
import ModalInstance from '@/modules/modal/ModalInstance';
import { versionCompare } from '@/lib/common';
// 老版激励视频服务
import VideoService from '@/lib/reward_video';
import { Xianwan } from '@/lib/xianwan';
import { mapActions } from 'vuex';

export default {
	...mapActions(['registerVideoCallback']),
	/**
	 * @description: 跳转链接
	 * @param { Object } param - 链接对象
	 */

	jumpLink(param) {
		const { task_type: type } = param;
		let { button_link: btnLink } = param;

		console.log('button_link', btnLink);

		const handleMiniProgramTask = (task) => {
			const { button_link, penetrate_params } = task;

			if (window.bridge && window.bridge.jumpByUrl) {
				window.bridge.jumpByUrl(button_link, penetrate_params);
			} else {
				console.log(`window.bridge.jumpByUrl(${button_link}, ${penetrate_params})`);
			}
		};

		if (btnLink.indexOf('kuaiyin://sdk/wechat_miniprogram') !== -1) {
			handleMiniProgramTask(param);
			return;
		}

		switch (type) {
			case 'read_free_novel': // 谷雨小说
				this.$sdkNew.appCall('OPEN_NOVEL');
				break;
			case (type.match(/^game_shandw/) || {}).input: // 闪电玩游戏
				this.handleShanDWTask(param);
				break;
			case 'store_praise_new': // 商店好评
				this.handleStorePraise(param);
				break;
			case (type.match(/^fu_neng/) || {}).input: // 赋能小游戏
				this.$sdkNew.appCall('OPEN_FU_NENG_GAME', btnLink);
				break;
			case (type.match(/^xiaoman/) || {}).input: // 小满游戏
				this.handleXiaoman(param);
				break;
			case (type.match(/^xianwan/) || {}).input: // 闲玩游戏
				new Xianwan().hrefToXianwan();
				break;
			default:
				this.$sdkNew.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify({ url: btnLink }));
		}
	},

	/**
	 * @description: 处理特殊任务
	 * @param { Object } param - 任务对象
	 */

	handleSpecify(param) {
		const { task_type: type } = param;

		switch (type) {
			case 'remind_click': // 推送任务
				this.handlePushTask(param);
				break;
			case 'big_turntable': // 幸运大转盘
				this.openFortune();
				break;
			default:
		}
	},

	/**
	 * @description: 处理闪电玩游戏任务
	 */

	handleShanDWTask(param) {
		let { client } = this.$store.getters;
		// 兼容userInfo中不存在信息的情况 -- 从client中取
		const nickname = client.nickname;
		let sex;
		if (client && client.gender) {
			sex = client.gender;
		} else {
			sex = sex === '男' ? '1' : sex === '女' ? '2' : '0';
		}
		const avatar = client && client.avatar_small ? client.avatar_small : '';

		const sdwUrl = $shandw.getShandwUrl({
			openID: client.uid,
			gameID: param.game_id || '',
			nickName: nickname,
			avatar,
			sex,
			phone: '',
			sdw_simple: 12,
		});

		this.$sdkNew.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify({ url: sdwUrl, back_mode: 'close' }));
	},

	/**
	 * @description: 处理查看推送任务
	 * @param { Object } param - 任务对象
	 */

	handlePushTask(param) {
		const { target_value: targetVal, task_value: taskVal } = param;

		// 检查通知开关状态
		this.checkNotify().then((state) => {
			const { modal } = this.$store.state;
			const { dispatch } = this.$store;

			if (+state) {
				// 1/2，打开 pushOff 弹窗
				const btnFn = () => {
					// 按钮点击回调
					modal.show = false;
					this.openNotify();
				};

				dispatch('openModal', {
					modalType: 'push-off',
					btnFn,
				});
			} else {
				// 0，弹出 pushOn 弹窗
				const btnFn = () => {
					// 按钮点击回调
					modal.show = false;
					if (!(targetVal < taskVal)) return; // 用户完成任务次数大于可获得奖励次数，将不再发放奖励

					this.$post(this.$api.NOTICE_SERVER_REWARD_API, { task_type: 'remind_click' }).then((res) => {
						dispatch('toast', { message: `恭喜获得${res.data.coin}金币` });
					});
				};

				dispatch('openModal', {
					modalType: 'push-on',
					btnFn,
				});
			}
		});
	},

	/**
	 * @description: 检查通知中心开关状态
	 */

	async checkNotify() {
		const { client } = this.$store.getters;
		// 定义推送设置渠道参数
		const channel = versionCompare(client['client-v'], '3.4.0') > -1 ? 'upush_default' : null;
		// 检查通知开关状态
		const state = await this.$sdkNew.appCall('IS_NOTIFICATION_ENABLED', channel); // 0: 成功；1：失败；2：还要再设置一次

		return state;
	},

	/**
	 * @description: 打开通知中心开关
	 */

	openNotify() {
		const { client } = this.$store.getters;
		// 定义推送设置渠道参数
		const channel = versionCompare(client['client-v'], '3.4.0') > -1 ? 'upush_default' : null;
		// 打开通知中心开关
		this.$sdkNew.appCall('OPEN_NOTIFICATION', null, channel);
	},

	/**
	 * @description: 处理明日签到任务
	 * @return:
	 */

	handleSign() {
		this.$post(this.$api.GET_SIGN_INFO_API).then((res) => {
			this.signInAPP(res.data, false);

			// 新版 h5 暂时注释
			/* this.$store.commit('welfare/activity/setModalConf', res.data);
			this.$store.dispatch('openModal', {
				modalType: 'day-sign',
			});*/
		});
	},

	/**
	 * @description: 签到
	 * @param {object} signInData - 签到信息
	 * @param {boolean} firstDaySign - 是否首次签到
	 * @return:
	 */

	signInAPP(signInData, firstDaySign, context) {
		if (firstDaySign) {
			this.trackClick({
				element_name: '每日签到-看视频',
			});
		} else {
			this.trackClick({
				element_name: '明日签到-看视频',
			});
		}

		const { data_list: dayList, extend_tasks: task, tips, next_day } = signInData;

		dayList.map((item) => {
			item.sign = false;
			if (next_day > item.day) {
				item.sign = true;
			} else if (next_day === item.day) {
				item.tomorrowlabel = true;
			}
		});

		let topButton = {};

		// 激励视频按钮显隐控制
		let isShowRewardVideo = this.isShowRewardVideo();

		if (task && task.length > 0) {
			console.log('task', task[0]);
			const { ad_info, task_record_id, task_type, reward_amount, ad_info_group, ad_platform_status } = task[0];
			const { master, fill } = ad_info;
			topButton = {
				isShow: isShowRewardVideo,
				label: `看视频再领${reward_amount}金币`,
				onClick: () => {
					let trackParams = {};
					if (firstDaySign) {
						trackParams = {
							element_name: '每日签到-看视频-打开',
						};

						// 标记当前视频位置
						this.$store.commit('setVideoPos', 'daySign');
					} else {
						trackParams = {
							element_name: '明日签到-看视频-打开',
						};

						// 标记当前视频位置
						this.$store.commit('setVideoPos', 'tomorrowDaySign');
					}
					const video = {
						master,
						fill,
						task_record_id,
						task_type,
						app_position: firstDaySign ? '每日签到' : '明日签到',
						trackParams,
						ad_info_group,
						ad_platform_status,
					};

					this.daySignModalInstance.close(true);
					this.daySignModalInstance = null;

					// 注册当前激励视频回调方法
					this.registerVideoCallback(this.videoEndCallback, this);
					// 观看激励视频
					this.watchRewardVideo(video);
				},
			};
		} else {
			topButton = {
				isShow: true,
				label: `再领225.76元听歌红包`,
				onClick: () => {
					let trackParams = {};
					if (firstDaySign) {
						trackParams = {
							element_name: '每日签到-再领225.76元听歌红包',
						};
					} else {
						trackParams = {
							element_name: '明日签到-再领225.76元听歌红包',
						};
					}
					this.openPage('/invite_friend', trackParams);
					this.daySignModalInstance.close(true);
					this.daySignModalInstance = null;
				},
			};
		}

		const daySignModal = new ModalInstance(day_sign_modal);

		this.daySignModalInstance = new daySignModal({
			tips,
			dayList,
			topButton: topButton,
			bottomButton: {
				label: '领取225.76元',
				onClick: () => {
					let trackParams = {};
					if (firstDaySign) {
						trackParams = {
							element_name: '每日签到-分享好友-打开',
						};
					} else {
						trackParams = {
							element_name: '明日签到-分享好友-打开',
						};
					}
					this.openPage('/invite_friend', trackParams);
					this.daySignModalInstance.close(true);
					this.daySignModalInstance = null;
				},
			},
			onClose: () => {
				if (task && task.length > 0) {
					// 存在视频任务
					if (firstDaySign) {
						this.trackClick({ element_name: '每日签到-看视频-关闭' });
					} else {
						this.trackClick({ element_name: '明日签到-看视频-关闭' });
					}
				} else {
					if (firstDaySign) {
						this.trackClick({ element_name: '每日签到-分享好友-关闭' });
					} else {
						this.trackClick({ element_name: '明日签到-分享好友-关闭' });
					}
				}
				this.daySignModalInstance = null;
			},
		});
	},

	/**
	 * @description: 观看激励视频 (老版观看激励视频方法，给签到等保留原有逻辑的弹窗使用)
	 * @param {object} video - 激励视频信息
	 */

	watchRewardVideo(video) {
		const {
			master,
			task_record_id,
			task_type,
			app_position,
			trackParams,
			ad_platform_status,
			ad_info_group: { ad_group_id, param_ext },
		} = video;
		let url_params = {};

		if (master.url_params) {
			url_params = master.url_params;
			Object.assign(url_params, { app_position: app_position });
		} else {
			url_params = { app_position: app_position };
		}

		const params = {
			task_record_id,
			task_type: task_type,
			sign: url_params.app_position,
			url_params,
		};

		const mediationParams = {
			...JSON.parse(param_ext),
			app_position,
		};
		console.log(ad_platform_status);
		console.log(mediationParams);
		const { client } = this.$store.getters;
		if (ad_platform_status && versionCompare(client['client-v'], '3.11.0') !== -1) {
			if (trackParams) {
				this.trackClick(trackParams);
			}
			this.loadMediationAd(ad_group_id, JSON.stringify(mediationParams));
		} else {
			const appName = this.$store.getters.client['app-name'] || 'kuaiyin';

			if (appName === 'kuaiyinyue') {
				this.watchRewardVideoOnFakePackage(task_type, task_record_id, app_position);
				return;
			}
			// 调用老版二十次激励视频播放服务
			VideoService._disPatchAdInfo()
				.then((res) => {
					VideoService.adInfo = {
						master: res.master,
						fill: res.fill,
					};

					VideoService.showRewardVideo(params)
						.then((res) => {
							if (res.code === 0) {
								if (trackParams) {
									this.trackClick(trackParams);
								}
							}
						})
						.catch((err) => {
							// 看视频受限
							if (err.code === -1) {
								console.log(`看视频受限`);
							}
						});
				})
				.catch((err) => {
					console.log('激励视频配置获取失败，error => ', err);
				});
		}
	},

	/**
	 * @description: 马甲包播放激励视频方法
	 */

	watchRewardVideoOnFakePackage(taskType, taskId, appPosition) {
		const mediationParams = {
			task_type: taskType,
			tid: taskId,
			uid: this.$store.getters.client.uid,
			app_position: appPosition,
		};
		// 22/11/14 由产品成润东提出快音悦 mid 写死 87
		this.loadMediationAd(87, JSON.stringify(mediationParams));
	},

	/**
	 * @description:  路由跳转方法(老版任务页跳转方法，仅用于保留的老版功能)
	 */

	openPage(path, trackParams, back_mode, third_part_name, link_type) {
		let url = '';

		if (/^\//.test(path)) {
			url = window.location.origin + path;
		} else {
			url = path;
		}

		let data = {
			url,
			type: 'reward_video',
		};
		if (back_mode) {
			Object.assign(data, { back_mode: back_mode });
		}
		if (third_part_name) {
			Object.assign(data, { third_part_name: third_part_name });
		}
		if (link_type) {
			Object.assign(data, { link_type: link_type });
		}
		if (trackParams) {
			this.trackClick(trackParams);
		}
		this.$sdk.openPageWithJSON(JSON.stringify(data));
	},

	/**
	 * @description:  弹窗是否显示激励视频按钮入口(老版任务页弹窗激励视频入口控制，仅用于保留的老版功能)
	 */

	isShowRewardVideo() {
		const { client } = this.$store.getters;

		if (client.platform === 'ios' && versionCompare(client['client-v'], '2.9.0') !== 1) {
			return false;
		} else if (client.platform === 'Android' && versionCompare(client['client-v'], '1.3.4') === 0) {
			return false;
		}

		return true;
	},

	/**
	 * @description: 关注微信公众号任务（保留老版方法）
	 * @return:
	 */

	popWxPlatformModal() {
		const wxPlatformModal = new ModalInstance(wx_platform_modal);

		this.wxPlatformModalInstance = wxPlatformModal({
			onClose: () => {
				this.wxPlatformModalInstance = null;
			},
			copyFun: () => {
				this.$sdkNew.appCall('COPY', '快音娱乐平台');
				this.$toast('复制成功');
			},
		});
	},

	/**
	 * @description: 处理商店好评任务
	 * @return:
	 */

	handleStorePraise(task) {
		console.log('商店好评任务!');
		this.$sdkNew.appCall('OPEN_PHONE_MARKET');
		/* const { task_type } = task;
		this.$post(this.$api.NOTICE_SERVER_REWARD_API, { task_type }); */
	},

	/**
	 * @description: 打开幸运大转盘
	 */

	openFortune() {
		const { activityPosition } = this.$store.state;
		const param = activityPosition ? { id: 4, position: activityPosition } : { id: 4 };

		this.$post(this.$api.INIT_TURNTABLE_API, param).then((res) => {
			this.$store.commit('setTurnTable', res.data);
			const {
				box: { status: chestStatus, progress: chestProgress, threshold: chestSum },
			} = res.data;
			this.$store.commit('setChest', { chestStatus, chestProgress, chestSum });
			this.$store.dispatch('openModal', {
				modalType: 'fortune-wheel',
				pos: { top: -0.12, right: -0.1 },
			});
		});
	},

	/**
	 * @description: 处理限时专属任务金任务
	 */

	handleLimitTask(task) {
		const {
			extra: { pop, amount },
		} = task;
		console.log('限时专属金任务为：task =>', task);

		const { limitTaskTime } = this.$store.getters['welfare/task/wallet'];

		// 任务已开启, 打开限时奖励弹窗二
		if (limitTaskTime > 0) {
			this.openLimitModalTwo({ reward: amount });
			return;
		}
		// 任务未开启, 打开限时奖励弹窗一
		pop.amount = amount;
		this.openLimitModalOne(pop);
	},

	/**
	 * @description: 处理弹窗任务
	 */

	handleModal(task) {
		const { task_type } = task;

		switch (task_type) {
			case 'sign_in_app': // 明日签到任务
				this.handleSign();
				break;
			case 'big_turntable': // 打开大转盘
				this.openFortune();
				break;
			default:
		}
	},

	/**
	 * @description: 处理小满跳转任务
	 */

	handleXiaoman(task) {
		const { button_link: link, third_part_name, link_type, back_mode } = task;
		const uid = this.$store.state.client.uid;
		const url = `${link}&consumerId=${uid}`;

		if (url) {
			this.openPage(url, null, back_mode, third_part_name, link_type);
		}
	},

	/**
	 * @description: 开启专属任务金限时任务
	 */
	async startLimitTask() {
		try {
			//await this.$post(this.$api.GET_LIMIT_TASK_BONUS);

			// 开启倒计时
			await this.getWalletInfo();
			this.$store.commit('welfare/task/changeStartCountDown', true);
			this.getPageInfo();
			this.$store.commit('welfare/task/setIsShowLimitTip', true);
		} catch (e) {
			console.log('领取专属任务金失败，error =>', e);
		}
	},

	/**
	 * @description: 福利活动页激励视频播放完毕回调
	 * @return:
	 */

	videoEndCallback() {
		VideoService.postVideoPlayEnd();
		const { videoPos } = this.$store.getters;
		console.log('激励视频播放完毕回调，位置为：', videoPos);

		// const rewardSign = this.appPosition;
		let trackParams = {};

		switch (videoPos) {
			case 'offline_income':
				trackParams = {
					element_name: '离线收益弹窗-看完视频获得奖励',
				};
				break;
			case 'online_income':
				trackParams = {
					element_name: '在线收益弹窗-看完视频获得奖励',
				};
				break;
			case 'daySign':
				trackParams = {
					element_name: '每日签到-看视频弹窗-获得奖励',
				};
				break;
			case 'tomorrowDaySign':
				trackParams = {
					element_name: '明日签到-看视频弹窗-获得奖励',
				};
				break;
			case 'hourSign':
				trackParams = {
					element_name: '整点签到-看视频弹窗-获得奖励',
				};
				break;
			case 'taskList':
				trackParams = {
					element_name: '看视频得金币-获得奖励',
				};
				break;
		}
		this.trackClick(trackParams);

		// 展示观看激励视频获得奖励的弹窗
		this.showRewardModal();
	},

	/**
	 * @description: 展示激励视频金币奖励弹窗
	 * @return:
	 */

	showRewardModal() {
		const rewardModal = new ModalInstance(reward_modal);
		const { videoReward } = this.$store.getters;

		this.$post(this.$api.GET_ONLINE_COMPLETE_API, { source: '' })
			.then((res) => {
				const { button1, button2 } = res.data;

				const rewardModalInstance = new rewardModal({
					rewardCoin: videoReward,
					topButton: {
						label: button1.txt,
						onClick: () => {
							this.doTask(button1);
							this.trackClick({ element_name: `视频奖励弹窗-${button1.txt}` });
							rewardModalInstance.close(true);
						},
					},
					bottomButton: {
						label: button2.txt,
						onClick: () => {
							this.doTask(button2);
							this.trackClick({ element_name: `视频奖励弹窗-${button2.txt}` });
							rewardModalInstance.close(true);
						},
					},
					onClose: () => {
						// 重置看视频位置的标签
						this.trackClick({ page_title: '任务页', element_name: '看视频获得奖励弹窗-关闭' });
					},
				});
			})
			.catch((err) => {
				console.log('激励视频回调弹窗报错：\n', err);

				const rewardModalInstance = new rewardModal({
					rewardCoin: videoReward,
					topButton: {
						label: '去领取翻倍金币再赚225.76元',
						onClick: () => {
							this.trackClick({ element_name: `视频奖励弹窗-去领取翻倍金币再赚225.76元` });
							this.openPage('/invite_friend');
							rewardModalInstance.close(true);
						},
					},
					bottomButton: {
						label: '领取225.76元',
						onClick: () => {
							this.trackClick({ element_name: `视频奖励弹窗-领取225.76元` });
							this.openPage('/invite_friend');
							rewardModalInstance.close(true);
						},
					},
					onClose: () => {
						// 重置看视频位置的标签
						this.trackClick({ page_title: '任务页', element_name: '看视频获得奖励弹窗-关闭' });
					},
				});
			});
	},

	/**
	 * @description: 单独刷新单条任务状态
	 * @param { Object } 被刷新的任务对象
	 */

	refreshTaskStatus(task) {
		const { task_type, task_id, tab_type, task_pos } = task;

		this.$post(this.$api.REFRESH_TASK_PROGRESS, { taskType: task_type }).then((res) => {
			const { data } = res;
			data.task_id = task_id;
			data.tab_type = tab_type;
			data.task_pos = task_pos;

			if (data.progress_status === 1) {
				// 数据埋点
				this.trackClick({
					page_title: '福利任务页',
					element_name: '任务列表_待领取曝光',
					remarks: `${data.task_id};${data.title}`,
				});
			}

			this.$store.commit('welfare/task/updateTask', data);
		});
	},
};



// WEBPACK FOOTER //
// ./src/root/handleTask.js